/**
 * "ResizeObserver loop completed with undelivered notifications" is the browser deferring a resize
 * callback to the next frame, not a failure; Datadog files every occurrence as a new error issue and
 * pages the alerts channel with it.
 *
 * `Uncaught "Script error."` is all the browser reports when a script from another origin, loaded
 * without `crossorigin` (Google Maps, Google Identity Services, Stripe.js, browser extensions), throws:
 * no message, no stack, no file. Our own bundle is same-origin and never reported this way, and the
 * calls we make into those scripts catch and report their errors with the real message instead.
 */
const ignoredErrorMessages = [/ResizeObserver loop/, /^Uncaught "Script error\.?"$/];

export function isReportableRumEvent(event: { type: string; error?: { message?: string } }): boolean {
  if (event.type !== 'error') {
    return true;
  }

  return !ignoredErrorMessages.some((pattern) => pattern.test(event.error?.message ?? ''));
}
